
export default {
  props: {
    'type': {
      type: String,
      default: 'responsive'
    },
    'adkey': {
      type: String,
      default: 'responsive'
    },
    'client': {
      type: String,
      default: 'responsive'
    },
    'adslot': {
      type: String,
      default: 'responsive'
    },
    'channel': {
      type: String,
      default: 'nochannel'
    }
  },
  data() {
    return {
      // use Nuxt RuntimeConfig to enable or disable Adsense
      isShow: this.$config.enableAdsense,
    }
  },
  mounted() {
    if (this.isShow) {
      this.$nextTick(() => {
        try {
          // this is required for each ad slot (calling this once will only load 1 ad)
          (window.adsbygoogle = window.adsbygoogle || []).push({})
        } catch (error) {
          console.error(error)
        }
      })
    }
  },
}
